import { render } from "./FoodTab.vue?vue&type=template&id=4e739d4f&ts=true"
import script from "./FoodTab.vue?vue&type=script&lang=ts"
export * from "./FoodTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__